import { createContext } from "react";

// Establishing Context API and exporting it to to NoteState.js

const noteContext = createContext();

export default noteContext;